import { useTranslation } from "react-i18next";
import DataListItemText from "./DataListItemText";
import type { ContractStatusNotification as AddOnBaseProductMissingNotificationType } from "@/gql/graphql";

type AddOnBaseProductMissingNotificationProps = {
  data: Pick<AddOnBaseProductMissingNotificationType, "contractNumber">;
};

const AddOnBaseProductMissingNotification = (
  props: AddOnBaseProductMissingNotificationProps
) => {
  const { data } = props;
  const { contractNumber } = data;
  const { t } = useTranslation();

  return (
    <div>
      <DataListItemText
        primary={t("notifications.add_on_base_product_missing.title", {
          number: contractNumber,
        })}
        secondary={t("notifications.add_on_base_product_missing.description")}
      />
    </div>
  );
};

export default AddOnBaseProductMissingNotification;
